export const slides = (state) => {
  return state.slides
}

export const slidesIOS = (state) => {
  return state.slidesIOS
}

export const searchStatus = (state) => {
  return state.searchStatus
}

export const menuStatus = (state) => {
  return state.menuStatus
}

export const loadingState = (state) => {
  return state.loading
}

export const screenSwiped = (state) => {
  return state.screenSwiped
}
export const people = (state) => {
  return state.people
}

export const offset = (state) => {
  return state.offset
}
